import { Component, OnInit, OnDestroy } from '@angular/core';
import { TxnService, TxnDataSource, Txn } from '../txns/txn.service';
import { FilterService } from './filter.service';

@Component({
  templateUrl: './search.component.html'
})
export class SearchComponent implements OnInit, OnDestroy {
  columns: string[] = ['date', 'account', 'fund', 'amount', 'tags', 'edit'];
  txnDataSource: TxnDataSource;

  constructor(
    private txnService: TxnService,
    private filterService: FilterService,
  ) {}

  ngOnInit() {
    this.txnDataSource = new TxnDataSource(this.txnService);
    this.filterService.dataSource = this.txnDataSource;
  }

  ngOnDestroy() {
    this.filterService.dataSource = null;
  }
}



// WEBPACK FOOTER //
// /srv/src/app/search/search.component.ts